import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Progress } from '../ui/progress';
import { TrendingUp, Truck } from 'lucide-react';
import { formatCurrency, formatPercentage } from '../../lib/utils';

/**
 * ProjectProgressCard - Card con avanzamento lavori e forniture
 */
export const ProjectProgressCard = ({
  lavoriPercentage,
  lavoriCompletedValue,
  lavoriTotalValue,
  forniturePercentage,
  fornitureDeliveredValue,
  fornitureTotalValue,
  hasForniture = false,
  showValues = true
}) => {
  return (
    <Card className="card-abitalo">
      <CardContent className="p-3 space-y-3">
        {/* Avanzamento Lavori (completamento voci a listino, non rettificato per stralci) */}
        <div>
          <div className="flex items-center justify-between mb-1">
            <div className="flex items-center gap-2">
              <TrendingUp className="w-4 h-4 text-[#FF7819]" />
              <span className="text-sm font-medium text-[#171717]">Avanzamento Lavori</span>
            </div>
            <span className="text-base font-semibold text-[#FF7819]">{formatPercentage(lavoriPercentage)}</span>
          </div>
          <Progress value={lavoriPercentage || 0} className="h-2" />
          <p className="text-xs text-[#737373] mt-1">Completamento voci a listino (diverso dal SAL contrattuale)</p>
          {showValues && (
            <p className="text-xs text-[#737373] mt-0.5">
              {formatCurrency(lavoriCompletedValue)} / {formatCurrency(lavoriTotalValue)}
            </p>
          )}
        </div>
        
        {/* Avanzamento Forniture e Materiali (F, G, H) */}
        {hasForniture && (
          <div>
            <div className="flex items-center justify-between mb-1">
              <div className="flex items-center gap-2">
                <Truck className="w-4 h-4 text-[#0078C8]" />
                <span className="text-sm font-medium text-[#171717]">Avanzamento Forniture e Materiali</span>
              </div>
              <span className="text-base font-semibold text-[#0078C8]">{formatPercentage(forniturePercentage)}</span>
            </div>
            <Progress value={forniturePercentage || 0} className="h-2 [&>div]:bg-[#0078C8]" />
            {showValues && (
              <p className="text-xs text-[#737373] mt-1">
                {formatCurrency(fornitureDeliveredValue)} / {formatCurrency(fornitureTotalValue)} consegnate
              </p>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ProjectProgressCard;
